import { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { base64ToString, Decrypt_Id_Name, stringToBase64 } from '@/Components/Common/Utility';
import { get_LocalStoreData } from '@/redux/actions/Agency';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AgencyContext } from 'Context/Agency';

const CaseManagementSidebar = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const localStoreData = useSelector((state) => state.Agency.localStoreData);
    const uniqueId = sessionStorage.getItem('UniqueUserID') ? Decrypt_Id_Name(sessionStorage.getItem('UniqueUserID'), 'UForUniqueUserID') : '';
    const { CaseStatus, caseManagementCounts, setCaseManagementCounts, getCaseManagementCounts } = useContext(AgencyContext);
    const useRouterQuery = () => {
        const params = new URLSearchParams(location.search);
        return {
            get: (param) => params.get(param)
        };
    };

    const query = useRouterQuery();
    let IncID = query?.get("IncId");
    let IncNo = query?.get("IncNo");
    let IncSta = query?.get("IncSta");
    let caseID = query?.get("CaseId");
    if (!caseID || caseID === 'null' || caseID === 'undefined') caseID = null;
    let CaseManagementPage = query?.get("CaseManagementPage");

    // Initialize state from URL parameter or default to 'home'
    const [caseManagementPage, setCaseManagementPage] = useState(CaseManagementPage);

    useEffect(() => {
        if (!localStoreData?.AgencyID || !localStoreData?.PINID) {
            if (uniqueId) dispatch(get_LocalStoreData(uniqueId));
        }
    }, [dispatch, localStoreData?.AgencyID, localStoreData?.PINID, uniqueId]);

    useEffect(() => {
        if (localStoreData?.AgencyID && IncID && caseID) {
            getCaseManagementCounts(localStoreData?.AgencyID, parseInt(base64ToString(IncID)), parseInt(caseID));
        } else {
            setCaseManagementCounts({})
        }
    }, [localStoreData?.AgencyID, IncID, caseID]);

    // Update state when URL parameter changes
    useEffect(() => {
        if (CaseManagementPage) {
            setCaseManagementPage(CaseManagementPage);
        }
    }, [CaseManagementPage]);

    // Get incident description from caseData or use a default
    const incidentDescription = '';

    // Navigation handler
    const handleNavigation = (page) => {
        if (!caseID && page !== 'home') return;

        // Update state
        setCaseManagementPage(page);

        // Update URL with page parameter
        const params = new URLSearchParams(location.search);
        params.set('CaseManagementPage', page);

        // Navigate with updated URL
        navigate(`${location.pathname}?${params.toString()}`, { replace: true });
    };

    // Navigation Item Component
    const NavItem = ({ page, label, badge, isHome = false }) => {
        const isActive = caseManagementPage === page;
        const isDisabled = !caseID && !isHome;

        return (
            <div
                onClick={() => {
                    if (!isDisabled) {
                        handleNavigation(page);
                    }
                }}
                className={`pl-3 py-2 d-flex align-items-center border-start border-3 transition-all ${isActive ? 'case-management-sidebar' : ''} ${isDisabled ? 'opacity-50 pe-none' : 'cursor-pointer'}`}
                onMouseEnter={(e) => {
                    if (!isDisabled && !isActive) {
                        e.currentTarget.classList.add('case-management-sidebar-hover');
                    }
                }}
                onMouseLeave={(e) => {
                    if (!isDisabled && !isActive) {
                        e.currentTarget.classList.remove('case-management-sidebar-hover');
                    }
                }}
                style={{ fontSize: '14px', gap: "6px" }}
            >
                <span
                    className="text-nowrap"
                    style={{
                        fontWeight: isActive ? '600' : '500',
                        color: isActive ? 'white' : isDisabled ? '#6c757d' : badge > 0 ? 'blue' : 'inherit',
                        cursor: isDisabled ? 'not-allowed' : 'inherit'
                    }}
                >
                    {label}
                </span>
                {badge > 0 && (
                    <span className="badge bg-secondary rounded-pill ms-2">
                        {badge}
                    </span>
                )}
            </div>
        );
    };

    return (
        <>
            <div className="w-100">
                {/* Header Section */}
                <div className="p-3 mb-3 border-bottom case-management-sidebar pl-4">
                    <div className="fs-4 fw-bold">
                        {IncNo ? `INC-${IncNo}` : 'INC-000000'}
                    </div>
                    <div className="small">Case Status :- {CaseStatus ? CaseStatus : ''}
                    </div>
                </div>
                {/* <ul className="recent">
                    {
                        caseManagementDataIncidentRecent?.slice(-5).map((val) => (
                            <li key={val.IncidentID}>
                                <Link style={{ display: 'flex', flexDirection: 'column' }}
                                    to={`/Inc-Home?IncId=${stringToBase64(val?.IncidentID)}&IncNo=${val?.Potentialincidents}&IncSta=${true}`}
                                    onClick={() => {
                                        navigate(`/Inc-Home?IncId=${stringToBase64(val?.IncidentID)}&IncNo=${val?.Potentialincidents}&IncSta=${true}`);
                                        setIncStatus(true);
                                        setUpdateCount(updateCount + 1);
                                    }}>
                                    <span>Incident-{val.Potentialincidents}</span>
                                </Link>
                            </li>
                        ))
                    }
                </ul> */}
                {/* Navigation Sections */}
                <div>
                    {/* OVERVIEW Section */}
                    <div className="mb-2">
                        <div>
                            <NavItem page="home" label="Home" isHome={true} />
                            <NavItem page="entities" label="Entities" badge={caseManagementCounts?.Entities} />
                            <NavItem page="caseTeam" label="Case Team" badge={caseManagementCounts?.CaseTeam} />
                            <NavItem page="caseEffort" label="Case Effort" badge={caseManagementCounts?.CaseEffort} />
                            <NavItem page="detectiveNotes" label="Detective Notes" badge={caseManagementCounts?.DetectiveNotes} />
                            <NavItem page="propertyEvidence" label="Property & Evidence" badge={caseManagementCounts?.PropertyRoom} />
                            <NavItem page="legalOrder" label="Legal Orders" />
                            <NavItem page="victimWitness" label="Victim & Witness Management" />
                            <NavItem page="caseReport" label="Case Report" badge={caseManagementCounts?.CaseReport} />
                            <NavItem page="caseTimeline" label="Case Timeline" />
                            {/* <NavItem page="chargingProsecution" label="Charging & Prosecution" /> */}
                            {/* <NavItem page="discovery" label="Discovery" /> */}
                            <NavItem page="caseClosure" label="Case Closure" />
                            <NavItem page="courtOutcome" label="Court Outcome" />
                            <NavItem page="caseHistory" label="Case History" />
                            {/* <NavItem page="auditLog" label="Case Audit Log" /> */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CaseManagementSidebar
